var pageBannerSettings = function(){
    var $bannerImgSrc = $('.page-banner .banner-img').attr('src');
    $('.page-banner .banner-img').closest('.page-banner').css({
        'background-image' : 'url(' + $bannerImgSrc + ')',
        'height' : $bannerImgSrc
    });
    $('.page-banner .banner-img').remove();
};
 
var pagePrealoder = function(){
    $('#page-preloader').fadeOut(500);
};


var radioItemTitleHeight = function(){
    var maxHeight = 0; 
    $(".page-content .radio-item").each(function(){   
        if ($(this).find('.title >a').height() > maxHeight){
            maxHeight = $(this).find('.title >a').height(); 
        }
    });
    $(".page-content .radio-item .title >a").height(maxHeight);  
};


(function( $ ) {

    //$("img.lazy").Lazy();  
    
    $(document).ready(function($) { 
        pagePrealoder(); 
        radioItemTitleHeight();
    }); 
 
    $(window).on('resize', function(){
        radioItemTitleHeight();
    }); 

    $(document).on('click', '.navbar-nav .nav-link', function(){
        if($('.navbar-collapse').hasClass('show')){
            $('.navbar-collapse').collapse('hide');
        }
    });

    $(document).on('click', '.sharing-options li .btn', function(){
        $.featherlight.close();
    });

    // $(document).ready(function($) {
    //     $('.dropup').each(function(){
    //         $(this).on('show.bs.dropdown', function () {
    //             var $customScroller = $('.custom-scrollbar');
    //             var cssTransform = $(this).find('.dropdown-menu').css('transform');
    //             console.log(cssTransform); 
    //         });
    //});     });
    // 

}(jQuery));
